<style src="./SmallView.scss" lang="scss"></style>

<template lang="pug">
  .small-view
    .small-view__cover
      img.small-view__image(
        v-if='cover'
        :src='`${HOST_URL}${cover}`'
        alt
      )
    .small-view__headline
      router-link.small-view__name(
        v-if='link'
        :to='link'
        :title='title'
      ) {{ title }}
      .small-view__artists(
        v-if='artists.length'
      )
        router-link.small-view__artist(
          v-for='artist in artists'
          :key='artist.id'
          :to='`/artists/${artist.id}`'
        ) {{ artist.name }}
    .small-view__meta
      .small-view__duration {{ duration | duration }}
</template>

<script>
import { HOST_URL } from "@/constants";

export default {
  inheritAttrs: false,
  name: "ListView",
  props: {
    type: {
      type: String,
      validator(value) {
        return ["track"].includes(value);
      }
    },
    cover: String,
    link: String,
    duration: Number,
    title: String,
    artists: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    HOST_URL
  })
};
</script>
